import { use } from "react";

import { FootnotesContext } from "lib/footnotes/use-footnotes";
import { ContentNode } from "lib/types";

import css from "./footnote.module.scss";

interface FootnoteProps {
  node: ContentNode;
}

export function Footnote({ node, ...props }: FootnoteProps) {
  const { open } = use(FootnotesContext)!;

  const number = extractNumber(node);

  function onClick() {
    if (node.f) {
      open({ number, content: node.f });
    }
  }

  return (
    <sup {...props} className={css.trigger} onClick={onClick}>
      [{number}]
    </sup>
  );
}

/** Извлекает номер сноски из текстовых детей ноды, например "[3]" → "3" */
function extractNumber(node: ContentNode): string {
  const text =
    node.c?.map(c => (typeof c === "string" ? c : "")).join("") ?? "";
  return text.match(/\d+/)?.[0] || "";
}
